
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { UserRole } from '../../core-module/models/role';
import { RoutingService } from '../services/routing.service';
import { ObservableBaseComponent } from './observable-base.component';
import { AccountService } from '@scl/core/services/account.service';

@Component({
    selector: 'shared-role-base',
    imports: [],
    template: ``,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class RoleBaseComponent extends ObservableBaseComponent {

  protected routingService = inject(RoutingService);
  protected accountService = inject(AccountService);

  get isAdmin() {
    return this.accountService.isInRole(UserRole.Admin);
  }

  get isSecondaryAdmin() {
    return this.accountService.isInRole(UserRole.SecondaryAdmin);
  }

  get userId() {
    return this.accountService.getUserId();
  }

  protected isAuthorized(roles: UserRole[]) {
    if (roles.length == 0
      || this.accountService.isInRole(UserRole.Admin)) {
      return true;
    }

    return this.accountService.hasAnyRoles(roles);
  }

  protected checkAuthorization(roles: string[]) {
    if (!this.isAuthorized(roles as UserRole[])) {
      this.routingService.navigate(['/unauthorized']);
    }
  }

}
